<document-acquisition-body
  (validityChanged)="validateForm($event)"
  (documentsLoaded)="updateDocumentLoadedState($event)">
</document-acquisition-body>
<div class="footer">
  <cp-button-widget-custom class="link-button" captionToTranslate="Cancel" (onClick)="cancel()"></cp-button-widget-custom>
  <cp-button-widget-custom
    [disabled]="!isFormValid"
    class="primary-button" captionToTranslate="OK" (onClick)="submit()"></cp-button-widget-custom>
</div>

